import { render } from "./Cod4Page.vue?vue&type=template&id=6dcb480e&scoped=true"
import script from "./Cod4Page.vue?vue&type=script&lang=js"
export * from "./Cod4Page.vue?vue&type=script&lang=js"

import "./Cod4Page.vue?vue&type=style&index=0&id=6dcb480e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb480e"]])

export default __exports__